import { CheckCircleIcon } from "@heroicons/react/20/solid";
import React from "react";
import { connect } from "react-redux";
import Spinner from "../../common/Spinner";
import XeroLogoBlue from "./assets/xero-logo.svg";
import { Actions as XEROACTIONS } from "./store/xeroActions";
import { useMemo } from "react";

const SendDataToXero = ({ periodId, sendPayPeriodToXero, sending, success, connected }) => {
	const status = useMemo(() => {
		if (sending)
			return (
				<Spinner
					style={{ color: "green", width: 12, position: "relative", top: -8, right: -14 }}
					className="animate-spin -ml-1 mr-3"
				/>
			);
		if (success)
			return (
				<CheckCircleIcon style={{ color: "green", width: 15, position: "relative", top: -8, right: -14 }} />
			);
	}, [connected, success, sending]);

	if (!connected || !status) return null;

	return (
		<div
			title="Send Data To Xero"
			className="js-send-to-xero"
			type="button"
			style={{
				height: "1.5em",
				width: "1.5em",
				borderRadius: "50%",
				position: "relative",
				cursor: "pointer",
				marginLeft: 10,
			}}
			onClick={() => {
				if (!sending) sendPayPeriodToXero(periodId);
			}}
		>
			<img
				src={XeroLogoBlue}
				style={{ width: 24.5 }}
			/>
			{status}
		</div>
	);
};

const mapStateToProps = (state, { periodId }) => {
	const { xero } = { ...state.integration?.accounting };
	return {
		connected: xero?.tenants?.length > 0 && Object.keys({ ...xero?.settings }).length > 1,
		connected: xero?.tenants?.length > 0,
		success: xero?.payruns?.includes(periodId),
		sending: xero?.sendingPayroll?.includes(periodId),
	};
};

const mapDispatchToProps = (dispatch) => ({
	sendPayPeriodToXero: (periodId) => dispatch(XEROACTIONS.sendPayPeriodToXero(periodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendDataToXero);
